import React from 'react';
import { ArrowLeft } from 'lucide-react';
import Button from '../Button';
import { cn } from '../cn';
const PageBackButton = ({ label = 'Back', onClick, className }) => {
    return (React.createElement(Button, { type: "button", variant: "ghost", size: "sm", className: cn('shrink-0 -ml-2', className), onClick: onClick },
        React.createElement(ArrowLeft, { className: "h-4 w-4 mr-1", "aria-hidden": true }),
        label));
};
export default PageBackButton;
